import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step_1_3_1 from "@/assets/integration-steps/reddit/step_1_3_1.png";
import step_1_3_2 from "@/assets/integration-steps/reddit/step_1_3_2.png";

interface Props {
  stepLabel?: string;
}

const RedditIntegrationStep3 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step reddit-step-3">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Create the exclusion audience in Reddit</h6>
    </div>
    <div className="wrapper">
      <p>
        Once you have at least 50 events, create the audience by going to{" "}
        <b>Audience Manager</b>, click <b>"New Audience"</b>, select{" "}
        <b>"Custom audience"</b> from the dropdown. A drawer will open:
      </p>
      <br />
      <img src={step_1_3_1} alt="Screenshot of step 1.3.1 Reddit Integration" />
      <br />
      <p>
        For <b>"Select audience type"</b>, choose <b>"Website Retargeting"</b>,
        and click <b>Next</b>. Put these details:
      </p>
      <ul>
        <li>
          <b>Audience name</b>: we recommend <b>"Opticks Negative Audience"</b>{" "}
          but you can put any name.
        </li>
        <li>
          <b>Conversion Event(s)</b>: select{" "}
          <b>"Custom: OpticksExcludeVisitor"</b>. If it doesn't appear, or you
          see the error <i>"Your audience must have at least 50 members"</i>,
          you will have to wait some more time until you receive more events in
          order to create the audience, which is a limitation of the Reddit Ads
          platform.
        </li>
      </ul>
      <br />
      <img src={step_1_3_2} alt="Screenshot of step 1.3.2 Reddit Integration" />
      <br />
    </div>
  </div>
);

export default RedditIntegrationStep3;
